export default __webpack_public_path__ + "static/media/time.42938d41.png";